module.exports = __webpack_public_path__ + "static/img/Complaint.160e6ff.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Complaint.jpeg
// module id = Mgxe
// module chunks = 7